<script setup lang="ts">
import { Head } from "@inertiajs/vue3"

import ErrorLayout from "@/layouts/ErrorLayout.vue"
</script>

<template>
  <Head title="403 — Acceso denegado" />

  <ErrorLayout
    title="Acceso denegado"
    subtitle="Error 403"
    description="Estamos preparando este módulo para el panel manager."
  />
</template>
